import { useCallback, useEffect, useState } from 'react';
/**
 * Generic hook for async data fetching with loading/error state.
 * Eliminates boilerplate across domain-specific hooks.
 *
 * @param fetchFn - Async function that returns the data
 * @param deps - Dependencies that trigger re-fetch when changed
 * @param errorMessage - Error message shown on failure
 */
export function useAsyncData(fetchFn, deps, errorMessage = 'Failed to load data') {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await fetchFn();
            setData(result);
        }
        catch {
            setError(errorMessage);
        }
        finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    useEffect(() => {
        void load();
    }, [load]);
    return { data, loading, error, load };
}
